import * as React from 'react';
import Button from '@mui/material/Button';
import Avatar from '@mui/material/Avatar';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import DialogTitle from '@mui/material/DialogTitle';
import Dialog from '@mui/material/Dialog';
import PersonIcon from '@mui/icons-material/Person';
import { blue } from '@mui/material/colors';
import { DialogActions, Stack } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { setImageMeta } from '../../redux/imageSlice';
import { setData } from '../../redux/annotationSlice';


export default function TGZFileSelection(props) {
  const { onClose, open } = props;
  const { options } = useSelector(state => state.images).maia_tgz_file
    const dispatch = useDispatch()
  const handleClose = () => {
    onClose();
  };

  const handleListItemClick = (value) => {
    dispatch(setImageMeta({
        name: 'maia_tgz_file', value: {
            path: value.path, name: value.name, url: value.url, rotated_url: value.rotated_url,
            selectedOption: value
        }
    }))
    dispatch(setData({
      name: 'selectedEye', checked: value.eye
    }))
    onClose()
  };

  return (
    <Dialog onClose={handleClose} open={open}>
      <DialogTitle>Set image</DialogTitle>
      <List sx={{ pt: 0 }}>
        {options?.map((option, index) => (
          <ListItem disableGutters key={`option-${index}`}>
            <ListItemButton onClick={() => handleListItemClick(option)} key={option.name}>
              <ListItemAvatar>
                <Avatar sx={{ bgcolor: blue[100], color: blue[600] }}>
                  <PersonIcon />
                </Avatar>
              </ListItemAvatar>
              <ListItemText primary={option.name} />
            </ListItemButton>
          </ListItem>
        ))}
        
      </List>
      <DialogActions>
        <Stack direction={"row"} spacing={2}>
        <Button variant='outlined' color="primary" size="small" onClick={onClose}>Close</Button>
        <Button variant='contained' color="primary" size="small">Select</Button>
        </Stack>
      </DialogActions>
    </Dialog>
  );
}
